let aesUtils = {};

var CryptoJS = require('crypto-js');
var key = CryptoJS.enc.Utf8.parse('WXZhidaCX_V1.0.0');
var iv = CryptoJS.enc.Utf8.parse('20180101Abcdefg!');

aesUtils.encrypt = function(jsonStr){
    var srcs = CryptoJS.enc.Utf8.parse(jsonStr)

    var encData = CryptoJS.AES.encrypt(srcs ,key,{
        iv:iv,
        mode: CryptoJS.mode.CBC,  
        padding: CryptoJS.pad.Pkcs7
    })

    return CryptoJS.enc.Hex.stringify(CryptoJS.enc.Base64.parse(encData.toString()));
}

aesUtils.decrypt = function(jsonStr){

    const jsonStrNew = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(jsonStr));


    var decryptStr = CryptoJS.AES.decrypt(jsonStrNew ,key,{
        iv:iv,
        mode: CryptoJS.mode.CBC,  
        padding: CryptoJS.pad.Pkcs7
    })


    let decryptedStr = decryptStr.toString(CryptoJS.enc.Utf8);
    return decryptedStr;
}


export default aesUtils;


// WEBPACK FOOTER //
// ./src/utils/aesUtil.js